import { render, staticRenderFns } from "./AdminPage.vue?vue&type=template&id=fafa253e&scoped=true"
import script from "./AdminPage.vue?vue&type=script&lang=ts"
export * from "./AdminPage.vue?vue&type=script&lang=ts"
import style0 from "./AdminPage.vue?vue&type=style&index=0&id=fafa253e&prod&scoped=true&lang=css"
import style1 from "./AdminPage.vue?vue&type=style&index=1&id=fafa253e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafa253e",
  null
  
)

export default component.exports